import { acceptObjectValue } from '../../field-viewer/shared-normalizers';
export const nestedFormViewer = {
    normalizeLoadedValue: acceptObjectValue
};

//# sourceMappingURL=definition-viewer.js.map